// extracted by mini-css-extract-plugin
export default {"hamburguer":"style_hamburguer__zsY9N","aUl":"style_aUl__7HeNV","header":"style_header__6pPcG","headLogo":"style_headLogo__d5oH4","linkBackground":"style_linkBackground__lJMza"};